import { roundNumberToNDecimalPlaces } from '@app/utils/helpers';
import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';

interface PreviewSheetTableSectionProps {
  columnName: string;
  items: {
    name: string;
    emissionsTonnes: number;
  }[];
}

export default function PreviewSheetTableSection({
  columnName,
  items,
}: PreviewSheetTableSectionProps) {
  return (
    <div className="mt-2 space-y-2 px-2">
      <div className="flex justify-between py-2">
        <Text className="">{columnName}</Text>
        <div className="flex place-content-end items-baseline space-x-2">
          <Text>Emissions</Text>
          <Unit variant="tCO2e" />
        </div>
      </div>

      {items?.map((item, idx) => {
        return (
          <div className="flex justify-between" key={idx}>
            <Text className="font-light">{item.name}</Text>
            <div className="flex place-content-end items-baseline space-x-2">
              <Text>
                {roundNumberToNDecimalPlaces(item.emissionsTonnes, 2, true)}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
}
